import { createApp, ref } from 'vue';
import ScanInterface from './components/ScanInterface.vue';

frappe.provide('frappe.scan');
frappe.provide('window.WarehouseScanComponents');

window.WarehouseScanComponents = {
    ScanInterface
};

frappe.scan = {
    _app: null,
    _selector: null,
    
    init(selector = '#scan-app', config = {}) {
        this._selector = selector;
        
        if (this._app) {
            this._app.unmount();
        }
        
        const app = createApp(ScanInterface);
        this._app = app;
        app.mount(selector);
        
        return app;
    },
    
    destroy() {
        if (this._app) {
            this._app.unmount();
            this._app = null;
        }
    },
    
    reload(config = {}) {
        this.destroy();
        return this.init(this._selector || '#scan-app', config);
    }
};

export default frappe.scan;
